import {PublisherAdUnitRequestStatus} from './publisher-ad-unit-request-status.enum';
import {WidgetType} from './widget-type.model';
import {Domain} from './domain.model';
import {Publisher} from './publisher.model';
import {DevicePlacement} from './device-placement.model';
export class PublisherAdUnitRequest {

  id: string;
  bidder: boolean;
  publisherEmail: string;
  publisherId: string;
  widgetTypeId: string;
  domainId: string;
  domainIds: string;
  domains: Domain[];
  newDomainUrl: string;
  newDomainUrls: string[];
  bridgeAdUnitId: string;
  comment: string;
  adUnitIdToReplace: string;
  status: PublisherAdUnitRequestStatus;
  createdOn: number;
  lastUpdatedOn: number;
  widgetType: WidgetType;
  publisher: Publisher;
  domain: Domain;
  devicePlacement: DevicePlacement;
  _domain: string;
  _domainUrls: string[];

}
